import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from '../utils/axiosConfig';
import { getApiBaseUrl } from '../utils/environment';
import { trackingService } from '../services/trackingService';
import logger from '../utils/logger';

const LocationContext = createContext();

export const useLocation = () => useContext(LocationContext);

export const LocationProvider = ({ children }) => {
  const [userLocation, setUserLocation] = useState(null);
  const [loading, setLoading] = useState(true);
  const API_BASE_URL = getApiBaseUrl();

  useEffect(() => {
    // Try to load saved location when context initializes
    const fetchSavedLocation = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setLoading(false);
          return;
        }

        const response = await axios.get(
          `locations/current/`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (response.data) {
          setUserLocation({
            id: response.data.id,
            latitude: response.data.latitude,
            longitude: response.data.longitude,
            name: response.data.address || 'Saved Location'
          });
        }
      } catch (error) {
        logger.log("No saved location found or error accessing location API");
      } finally {
        setLoading(false);
      }
    };

    fetchSavedLocation();
  }, []);

  // Save location to backend whenever it changes
  useEffect(() => {
    if (!userLocation) return;

    const saveLocation = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        await axios.post(
          `locations/current/update/`,
          {
            latitude: userLocation.latitude,
            longitude: userLocation.longitude,
            address: userLocation.name
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      } catch (error) {
        // Silently ignore — not critical
      }
    };

    saveLocation();
  }, [userLocation]);

  const value = {
    userLocation,
    setUserLocation,
    loading
  };

  return (
    <LocationContext.Provider value={value}>
      {children}
    </LocationContext.Provider>
  );
};
